module.exports = __webpack_public_path__ + "static/media/ewl.953974f1.png";